import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const links = [
  { label: "Services", id: "services" },
  { label: "The Work", id: "work" },
  { label: "Reviews", id: "reviews" },
  { label: "About", id: "about" },
];

export const Navbar = ({ onBook }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-barber-bg/95 border-b border-barber-gold/25 backdrop-blur"
          : "bg-gradient-to-b from-black/85 via-black/40 to-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center group"
        >
          <img
            src="/barber-parlor-logo.png"
            alt="The Barber Parlor"
            className="h-12 sm:h-16 w-auto transition-transform group-hover:scale-105"
          />
        </button>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="relative text-sm uppercase tracking-widest text-barber-cream/80 hover:text-barber-gold transition-colors after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-barber-gold after:transition-all hover:after:w-full"
            >
              {l.label}
            </button>
          ))}
          <a
            href="tel:+17742322759"
            className="flex items-center gap-2 text-sm text-barber-cream/80 hover:text-barber-gold transition-colors"
          >
            <Phone className="w-4 h-4" /> (774) 232-2759
          </a>
          <Link
            to="/barber"
            data-testid="nav-barber"
            className="text-sm uppercase tracking-widest text-barber-gold hover:text-barber-cream transition-colors"
          >
            Meet the Barber
          </Link>
          <Button
            data-testid="nav-book-btn"
            onClick={onBook}
            className="rounded-none btn-gold font-semibold tracking-wide"
          >
            Book Now
          </Button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-barber-cream"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-barber-surface border-t border-barber-gold/20 px-5 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-barber-cream uppercase tracking-widest text-sm"
            >
              {l.label}
            </button>
          ))}
          <a href="tel:+17742322759" className="text-barber-muted text-sm">
            (774) 232-2759
          </a>
          <Link
            to="/barber"
            data-testid="nav-mobile-barber"
            className="text-left text-barber-gold uppercase tracking-widest text-sm"
            onClick={() => setOpen(false)}
          >
            Meet the Barber
          </Link>
          <Button
            data-testid="nav-mobile-book-btn"
            onClick={() => {
              setOpen(false);
              onBook();
            }}
            className="rounded-none btn-gold font-semibold"
          >
            Book Now
          </Button>
        </div>
      )}
    </nav>
  );
};
